<template>
    <div>
        <VJoyInput
            v-model="model"
            name="headline"
            :minlength="jobTitle.min"
            :maxlength="jobTitle.max"
            :invalid="errors.length > 0"
            data-testid="profile-edition-section-headline-input"
        >
            {{ $t('profile.section.header.edit.headline.title') }}
        </VJoyInput>
        <VJoyFormError v-if="errors.length" class="joy-mt-2" :errors="errors" data-testid="profile-edition-section-headline-error" />
        <VJoyHighlight class="joy-mt-4" level="info" display-icon>
            {{ $t('profile.section.header.edit.headline.highlight') }}
        </VJoyHighlight>
    </div>
</template>

<script setup lang="ts">
    import {storeToRefs} from 'pinia';
    import {VJoyInput, VJoyFormError, VJoyHighlight} from '@maltjoy/core-vue';
    import {useRulesStore} from '~/store/rules/rulesStore';

    const model = defineModel<string>({required: true});
    defineProps<{
        errors: string[];
    }>();

    const {jobTitle} = storeToRefs(useRulesStore());
</script>
